import { Modal, useModals } from 'almanac-ui/Modal'

interface Props {
  onSubmit: () => void
  onClose: () => void
}

export const ConfirmModal = ({ onSubmit, onClose }: Props) => {
  const { closeModal } = useModals()

  return (
    <Modal.Root size="sm">
      <Modal.Header
        title="End currently open review and proceed"
        isConfirmation
        subHeader="This document has an open review that will automatically close. A new review will open tied to this status change."
      />
      <Modal.Footer isConfirmation>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton
            onPress={() => {
              closeModal()
              onClose()
            }}
            size="lg"
            variant="secondary"
          >
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton
            onPress={() => {
              closeModal()
              onSubmit()
            }}
            size="lg"
            variant="primary"
          >
            Confirm
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
